// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPnlMetricDto } from './IPnlMetricDto';
import {
    IPnlMetricDtoFromJSON,
    IPnlMetricDtoFromJSONTyped,
    IPnlMetricDtoToJSON,
    IPnlMetricDtoToJSONTyped,
} from './IPnlMetricDto';

/**
 * 
 * @export
 * @interface IAggregatedPnlMetricDto
 */
export interface IAggregatedPnlMetricDto {
    /**
     * 
     * @type {IPnlMetricDto}
     * @memberof IAggregatedPnlMetricDto
     */
    thirty_day_pnl?: IPnlMetricDto;
    /**
     * 
     * @type {IPnlMetricDto}
     * @memberof IAggregatedPnlMetricDto
     */
    year_to_date_pnl?: IPnlMetricDto;
    /**
     * 
     * @type {IPnlMetricDto}
     * @memberof IAggregatedPnlMetricDto
     */
    lifetime_pnl?: IPnlMetricDto;
}

/**
 * Check if a given object implements the IAggregatedPnlMetricDto interface.
 */
export function instanceOfIAggregatedPnlMetricDto(value: object): value is IAggregatedPnlMetricDto {
    return true;
}

export function IAggregatedPnlMetricDtoFromJSON(json: any): IAggregatedPnlMetricDto {
    return IAggregatedPnlMetricDtoFromJSONTyped(json, false);
}

export function IAggregatedPnlMetricDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAggregatedPnlMetricDto {
    if (json == null) {
        return json;
    }
    return {
        
        'thirty_day_pnl': json['thirty_day_pnl'] == null ? undefined : IPnlMetricDtoFromJSON(json['thirty_day_pnl']),
        'year_to_date_pnl': json['year_to_date_pnl'] == null ? undefined : IPnlMetricDtoFromJSON(json['year_to_date_pnl']),
        'lifetime_pnl': json['lifetime_pnl'] == null ? undefined : IPnlMetricDtoFromJSON(json['lifetime_pnl']),
    };
}

export function IAggregatedPnlMetricDtoToJSON(json: any): IAggregatedPnlMetricDto {
    return IAggregatedPnlMetricDtoToJSONTyped(json, false);
}

export function IAggregatedPnlMetricDtoToJSONTyped(value?: IAggregatedPnlMetricDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'thirty_day_pnl': IPnlMetricDtoToJSON(value['thirty_day_pnl']),
        'year_to_date_pnl': IPnlMetricDtoToJSON(value['year_to_date_pnl']),
        'lifetime_pnl': IPnlMetricDtoToJSON(value['lifetime_pnl']),
    };
}

